module.exports = __webpack_public_path__ + "assets/60e92a37cb4ec4348935206e324684ea.svg";